var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M8.991,11.991c2.483,0,4.495-2.013,4.495-4.495S11.473,3,8.991,3S4.495,5.013,4.495,7.495 S6.508,11.991,8.991,11.991z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M1.498,20.981c0,0-1.498,0-1.498-1.498s1.498-5.994,8.991-5.994s8.991,4.495,8.991,5.994 c0,1.498-1.498,1.498-1.498,1.498H1.498z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M16.483,5.248c0-0.414,0.336-0.749,0.749-0.749h5.994c0.414,0,0.749,0.335,0.749,0.749 s-0.335,0.749-0.749,0.749h-5.994C16.818,5.997,16.483,5.661,16.483,5.248z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M17.232,8.994c-0.414,0-0.749,0.335-0.749,0.749s0.336,0.749,0.749,0.749h5.994 c0.414,0,0.749-0.335,0.749-0.749s-0.335-0.749-0.749-0.749H17.232z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M20.229,13.489c-0.414,0-0.749,0.335-0.749,0.749s0.335,0.749,0.749,0.749h2.997 c0.414,0,0.749-0.335,0.749-0.749s-0.335-0.749-0.749-0.749H20.229z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E8E",
    d: "M20.229,17.984c-0.414,0-0.749,0.335-0.749,0.749c0,0.414,0.335,0.749,0.749,0.749h2.997 c0.414,0,0.749-0.335,0.749-0.749c0-0.414-0.335-0.749-0.749-0.749H20.229z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountGray);
export default __webpack_public_path__ + "static/media/account-gray.e7d550418fd8ca507122c90a620aa468.svg";
export { ForwardRef as ReactComponent };